import React from 'react';
import { Star, ExternalLink } from 'lucide-react';
import { reviews, companyInfo } from '../data/mock';

const GoogleBadge = () => (
  <span className="inline-flex items-center gap-1.5 text-xs text-gray-400 bg-[#0a0a0a] border border-[#2a2a2a] rounded-full px-3 py-1">
    <svg viewBox="0 0 24 24" className="w-3.5 h-3.5" aria-hidden="true">
      <path fill="#4285F4" d="M23.5 12.3c0-.8-.1-1.6-.2-2.3H12v4.4h6.5c-.3 1.5-1.1 2.7-2.4 3.6v3h3.9c2.3-2.1 3.5-5.2 3.5-8.7z" />
      <path fill="#34A853" d="M12 24c3.2 0 6-1.1 7.9-2.9l-3.9-3c-1.1.7-2.4 1.2-4 1.2-3.1 0-5.7-2.1-6.7-4.9H1.4v3.1C3.4 21.4 7.4 24 12 24z" />
      <path fill="#FBBC05" d="M5.3 14.4c-.5-1.5-.5-3.2 0-4.7V6.6H1.4c-1.7 3.4-1.7 7.4 0 10.8l3.9-3z" />
      <path fill="#EA4335" d="M12 4.8c1.7 0 3.3.6 4.5 1.8l3.4-3.4C17.9 1.2 15.1 0 12 0 7.4 0 3.4 2.6 1.4 6.6l3.9 3.1c1-2.8 3.6-4.9 6.7-4.9z" />
    </svg>
    Avaliação no Google
  </span>
);

const ReviewCard = ({ r, index }) => (
  <article className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-lg p-7 flex flex-col hover:border-[#FF6B00] transition-colors" data-testid={`review-card-${index + 1}`}>
    <div className="flex gap-1 mb-4" aria-label={`${r.stars} estrelas`}>
      {Array.from({ length: r.stars }).map((_, i) => (
        <Star key={i} size={20} className="text-[#FBBC05] fill-[#FBBC05]" />
      ))}
    </div>
    <p className="text-gray-200 leading-relaxed flex-1 mb-6">“{r.text}”</p>
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div>
        <div className="text-white font-semibold">{r.name}</div>
        {r.badge && <div className="text-gray-500 text-xs">{r.badge}</div>}
      </div>
      <GoogleBadge />
    </div>
  </article>
);

const ReviewsSection = () => (
  <section id="reviews" className="py-24 bg-[#111111]" data-testid="reviews-section">
    <div className="max-w-7xl mx-auto px-6">
      <div className="text-center mb-14">
        <span className="text-[#FF6B00] font-bold text-sm uppercase tracking-wider">Avaliações do Google</span>
        <h2 className="text-4xl md:text-5xl font-bold text-white mt-4 mb-6">
          O que nossos <span className="text-[#FF6B00]">clientes dizem</span>
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {reviews.map((r, i) => <ReviewCard key={r.name} r={r} index={i} />)}
      </div>
      <div className="text-center mt-12">
        <a
          href={companyInfo.mapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="google-reviews-link"
          className="inline-flex items-center gap-2 border-2 border-[#FF6B00] text-[#FF6B00] px-8 py-4 rounded-md hover:bg-[#FF6B00] hover:text-white transition-all duration-300 font-semibold"
        >
          Ver todas as avaliações no Google
          <ExternalLink size={18} />
        </a>
      </div>
    </div>
  </section>
);

export default ReviewsSection;
